import React, { FC }                                  from 'react';
import { formatOption }                               from '../../../../util';
import { SelectField }                                from '../../../components/forms';
import { SUBSCRIPTION_TYPE_INFO, SUBSCRIPTION_TYPES } from '../../../../constants/ProductEnums';
import { PreSelectedSelectField }                     from '../../../../types';

const Dropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let options = [
		formatOption( SUBSCRIPTION_TYPES.FREEUNLIMITED, SUBSCRIPTION_TYPE_INFO.FREEUNLIMITED.LABEL ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

Dropdown.defaultProps = {};

export { Dropdown as ProjectSubscriptionTypeDropdown }
